import { api } from "../../utils/api";
import { LoginHelper } from "../../utils/LoginHelper";

function clipIdFromCard(card) {
	if (card?.id != null) {
		return Number(card.id);
	}
	const match = String(card?.href || "").match(/video_clip_detail\/(\d+)/);
	return match ? Number(match[1]) : null;
}

function carouselHasClips(carousels) {
	return carousels.some((carousel) =>
		(carousel.items ?? []).some((item) => item.card?.kind === "video_clip"),
	);
}

/** همان can_watch و access_type لیست کلیپ‌ها را روی کارت‌های هوم می‌نشاند. */
export async function enrichCarouselsClipAccess(carousels) {
	if (!Array.isArray(carousels) || !carouselHasClips(carousels)) {
		return carousels;
	}

	const token = LoginHelper.getToken();
	if (!token) {
		return carousels;
	}

	let clipList;
	try {
		clipList = await api.videoClipList({ token });
	} catch {
		return carousels;
	}

	const byId = new Map((clipList ?? []).map((clip) => [clip.id, clip]));

	return carousels.map((carousel) => ({
		...carousel,
		items: (carousel.items ?? []).map((item) => {
			const card = item.card;
			if (card?.kind !== "video_clip") {
				return item;
			}
			const clipId = clipIdFromCard(card);
			const fromList = clipId != null ? byId.get(clipId) : null;
			if (!fromList) {
				return item;
			}
			return {
				...item,
				card: {
					...card,
					id: fromList.id,
					access_type: fromList.access_type ?? card.access_type,
					credit_cost: fromList.credit_cost ?? card.credit_cost,
					can_watch: fromList.can_watch,
				},
			};
		}),
	}));
}
